export enum ContractorReportsFilter {
  campaignsIdArray = 'filters[campaign][id][]',
  serviceIdArray = 'filters[service][id][]',
  from = 'filters[reports][from]',
  to = 'filters[reports][to]',
  dateInterval = 'filters[reports][date-interval]',
}

export type TSTokenModel = {
  token: string;
};
